import { Grid, Typography, useMediaQuery, useTheme } from "@mui/material";
import { useCallback } from "react";

const TitleComponent = ({
    title,
    description="",
    centerMode=false,
    removePadding=false,
    ...other
}) => {
    const theme = useTheme();

    const getFirstWord = useCallback(() => {
        const firstWordEndIndex = title.indexOf(' ');
        return title.substring(0, firstWordEndIndex);
    }, [title]);

    const getRestOfTheWords = useCallback(() => {
        const firstWordEndIndex = title.indexOf(' ');
        return title.substring(firstWordEndIndex);
    }, [title]);

    const isLgUp = useMediaQuery(theme.breakpoints.up('lg'));
    const isMdUp = useMediaQuery(theme.breakpoints.up('md'));

    const getStarSize = useCallback(() => {
        if(isLgUp) return 30;

        if(isMdUp) return 24;

        return 16;
    }, [isLgUp, isMdUp]);

    return (
        <>
            <Grid
                direction='row'
                justifyContent='center'
                alignItems='end'
                width='100%'
                container
                spacing={{xs: 2, md: centerMode && description ? 4 : 0}}
                pb={{xs: removePadding ? 0 : description ? 5 : 2, md: removePadding ? 0 : centerMode ? 6 : description ? 10 : 5}}
                {...other}
            >
                <Grid size={{xs: 12, md: centerMode || description === "" ? 12 : 6}}>
                    <Typography
                        fontWeight={700}
                        fontSize={{xs: 30, md: 45, lg: 60}}
                        textAlign={{xs: 'center', md: centerMode ? 'center' : 'left'}}
                        lineHeight={1}
                        color={theme.palette.text.primary}
                        pr={{xs: 0, md: centerMode ? 0 : 10}}
                        letterSpacing={-1}
                    >
                        <span 
                            style={{
                                fontWeight: 500,
                                fontSize: getStarSize(),
                                color: theme.palette.text.secondary,
                            }}
                        >
                            {getFirstWord()}
                        </span>
                        <span>{getRestOfTheWords()}</span>
                    </Typography>
                </Grid>

                <Grid size={{xs: 12, md: centerMode ? 12 : 6}}>
                    {
                        description
                        ?
                        <Typography
                            fontWeight={500}
                            fontSize={{xs: 12, md: 12, lg: 16}}
                            textAlign={{xs: 'center', md: centerMode ? 'center' : 'right'}}
                            lineHeight={{xs: 1.5, md: 1.75}}
                            color={theme.palette.text.secondary}
                            pl={{xs: 0, md: centerMode ? 0 : 10}}
                        >
                            {description}
                        </Typography>
                        :
                        <></>
                    }
                </Grid>
            </Grid>
        </>
    );
}

export default TitleComponent;